import { apiGet, apiPost } from '../api-client'

export interface CreatorSeriesSummary {
  id: string
  title: string
  synopsis?: string
  genre?: string
  language?: string
  status?: string
  episodeCount?: number
  coverImage?: string
  updatedAt?: string
}

export interface CreatorEpisodeSummary {
  id: string
  title: string
  filmId: string
  episodeNumber: number
  status: string
  duration?: number
  releasedAt?: string
}

export async function listCreatorSeries(): Promise<CreatorSeriesSummary[]> {
  const res = await apiGet<{ items: any[]; totalCount: number }>('/creator/series')
  return res.items.map((raw) => ({
    id: raw.id ?? raw.filmId,
    title: raw.title,
    synopsis: raw.synopsis,
    genre: raw.genre,
    language: raw.language,
    status: raw.status,
    episodeCount: raw.episodeCount,
    coverImage: raw.coverImage,
    updatedAt: raw.updatedAt,
  }))
}

export async function listCreatorEpisodesForSeries(
  seriesId: string,
): Promise<CreatorEpisodeSummary[]> {
  const series = await apiGet<any>(`/creator/series/${seriesId}`)
  const episodes = Array.isArray(series.episodes) ? series.episodes : []
  return episodes.map((ep: any) => ({
    id: ep.id ?? ep.episodeId,
    title: ep.title,
    filmId: seriesId,
    episodeNumber: ep.episodeNumber ?? 0,
    status: ep.status,
    duration: ep.duration,
    releasedAt: ep.releasedAt,
  }))
}

export async function createSeries(payload: {
  title: string
  synopsis: string
  genre: string
  language: string
  coverImageKey: string
}): Promise<CreatorSeriesSummary> {
  const res = await apiPost<any>('/creator/series', payload)
  return {
    id: res.id ?? res.filmId,
    title: res.title,
    synopsis: res.synopsis,
    genre: res.genre,
    language: res.language,
    status: res.status,
    episodeCount: res.episodeCount,
    coverImage: res.coverImage,
    updatedAt: res.updatedAt,
  }
}


